import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class ListElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  content = 'No content';
  title = 'No content';
  icon = '';
  link = new TbLink();

  static normalizeInPlace(element: ListElement): ListElement {
    const pureElement = new ListElement();

    element.content = element.content ?? pureElement.content;
    element.title = element.title ?? pureElement.title;
    element.icon = element.icon ?? pureElement.icon;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);

    return element;
  }
}
